import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/api/client'
import { queryKeys } from '@/api/queryKeys'

export interface UserPreferences {
  homePage?: string | null
  uiLocale?: string | null
  defaultCalendarView?: string | null
  defaultTasksView?: string | null
  firstDayOfWeek?: string | null
  dateFormat?: string | null
  timeFormat?: string | null
  theme?: string | null
  numberFormat?: string | null
  sidebarCollapsed?: boolean | null
}

/**
 * Thin hook that returns the current user's preferences from the cache.
 * Uses `staleTime: Infinity` to avoid redundant network calls — the
 * PreferencesSection and AppLayout both use the same key and will
 * invalidate on any PUT.
 */
export function useUserPreferences(): UserPreferences | undefined {
  const { data } = useQuery<UserPreferences>({
    queryKey: queryKeys.settings.preferences,
    queryFn: async () => { const { data } = await apiClient.get('/team-members/me/preferences'); return data },
    staleTime: 5 * 60 * 1000,
  })
  return data
}
